import React from 'react';
import { Toaster } from 'react-hot-toast';

import { STICKY_FLOOR_HEIGHT_PROPERTY } from '@lib/ads/snack';

// react-hot-toast's own gap between its container and the viewport edges.
const TOAST_EDGE_OFFSET_IN_PX = 16;

type ToastContainerProps = {
  isAppView: boolean;
};

const ToastContainer = ({ isAppView }: ToastContainerProps) => {
  return (
    <Toaster
      position="bottom-right"
      // Keep toasts above Snack's floor ad while it shows one (FFH-3482).
      containerStyle={{
        bottom: `calc(${TOAST_EDGE_OFFSET_IN_PX}px + var(${STICKY_FLOOR_HEIGHT_PROPERTY}, 0px))`
      }}
      containerClassName={`[&>div]:!hidden [&>div:nth-child(-n+2)]:!flex [&_[role=status]]:block ${
        isAppView ? 'mb-10' : ''
      }`}
      toastOptions={{
        duration: 4000,
        style: {
          minWidth: '300px',
          display: 'flex',
          padding: '0',
          background: 'transparent',
          boxShadow: 'none',
          border: 'none'
        },
        success: {
          style: {
            background: 'transparent'
          }
        },
        loading: {
          style: {
            background: 'transparent'
          }
        },
        error: {
          style: {
            background: 'transparent'
          }
        }
      }}
    />
  );
};

export default ToastContainer;
